/* NOBS CRO optimizations — 2026-08-30 */
(function () {
  'use strict';

  function applyAttributes(selector, attributes) {
    document.querySelectorAll(selector).forEach(function (field) {
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];
        if (value === null) field.removeAttribute(name);
        else field.setAttribute(name, value);
      });
      field.dataset.nobsAutofillReady = 'true';
    });
  }

  function enhanceCheckoutAutofill() {
    applyAttributes(
      'input[name="first_name"], input[name$="[first_name]"], input[id*="first_name" i], input[placeholder*="Собствено име" i]',
      { autocomplete: 'given-name', enterkeyhint: 'next' }
    );
    applyAttributes(
      'input[name="last_name"], input[name$="[last_name]"], input[id*="last_name" i], input[placeholder*="Фамилно име" i]',
      { autocomplete: 'family-name', enterkeyhint: 'next' }
    );
    applyAttributes(
      'input[name="email"], input[name$="[email]"], input[id*="email" i], input[placeholder*="Имейл" i], input[placeholder*="E-mail" i]',
      { type: 'email', autocomplete: 'email', inputmode: 'email', enterkeyhint: 'next' }
    );
    applyAttributes(
      'input[name="phone"]:not(#mw-phone2), input[name$="[phone]"]:not(#mw-phone2), input[id*="phone" i]:not(#mw-phone2), input[type="tel"]:not(#mw-phone2), input[placeholder*="телефон" i]:not(#mw-phone2)',
      { type: 'tel', autocomplete: 'tel', inputmode: 'tel', enterkeyhint: 'next' }
    );
    applyAttributes(
      'input[name="address1"], input[name$="[address1]"], input[id*="address1" i], input[placeholder="Адрес" i]',
      { autocomplete: 'address-line1', enterkeyhint: 'next' }
    );
    applyAttributes(
      'input[name="address2"], input[name$="[address2]"], input[id*="address2" i], input[placeholder*="Етаж" i], input[placeholder*="апартамент" i]',
      { autocomplete: 'address-line2', enterkeyhint: 'next' }
    );
    applyAttributes(
      'input[name="zip"], input[name$="[zip]"], input[id*="postal" i], input[placeholder*="Пощенски код" i]',
      { autocomplete: 'postal-code', inputmode: 'numeric', enterkeyhint: 'next' }
    );
    applyAttributes(
      'input[name="city"], input[name$="[city]"], input[id*="city" i], input[placeholder="Град" i]',
      { autocomplete: 'address-level2', enterkeyhint: 'next' }
    );
  }

  var middlewareFallbackTimer = 0;

  function cleanMiddlewareCheckout() {
    var duplicatePhone = document.querySelector('#mw-modal #mw-phone2');
    if (duplicatePhone) {
      duplicatePhone.removeAttribute('autocomplete');
      duplicatePhone.setAttribute('tabindex', '-1');
      duplicatePhone.setAttribute('aria-hidden', 'true');
    }
  }

  function middlewareCheckoutReady() {
    var button = document.querySelector('.mw-btn-modal');
    if (!button) return false;
    var rect = button.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 &&
      /преминаване към плащане/i.test(button.textContent || '');
  }

  function setMiddlewareFallback(active) {
    document.documentElement.classList.toggle('nobs-mw-fallback-active', Boolean(active));
  }

  function armMiddlewareFallback() {
    window.clearTimeout(middlewareFallbackTimer);
    setMiddlewareFallback(false);
    if (middlewareCheckoutReady()) return;
    middlewareFallbackTimer = window.setTimeout(function () {
      setMiddlewareFallback(!middlewareCheckoutReady());
    }, 4500);
  }

  function enhanceStickyCta() {
    document.querySelectorAll('[data-nobs-sticky-add]').forEach(function (button) {
      button.setAttribute('aria-label', 'Абонирай се за 1 € на ден');
      button.setAttribute('title', 'Абонирай се за 1 € на ден');
    });
  }

  function enhance() {
    enhanceCheckoutAutofill();
    cleanMiddlewareCheckout();
    enhanceStickyCta();
    if (middlewareCheckoutReady()) setMiddlewareFallback(false);
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest(
      '.header__icon--cart, #cart-icon-bubble, a[href="/cart"], a[href$="/cart"]'
    );
    if (target) armMiddlewareFallback();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhance();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(enhance, 800);
  window.setTimeout(enhance, 2400);
})();


    (function () {
      // Keep listeners on the page: Appstle/theme updates may replace either button.
      if (window.nobsMagCoreStickyController) {
        window.nobsMagCoreStickyController.refresh();
        return;
      }

      var stickyFrame = 0;
      document.documentElement.setAttribute('data-nobs-sticky-controller', 'v2');
      function findMainAddButton() {
        var buttons = document.querySelectorAll('product-form button[name="add"], form[action*="/cart/add"] button[name="add"], product-form button[type="submit"]');
        for (var i = 0; i < buttons.length; i += 1) {
          var button = buttons[i];
          var rect = button.getBoundingClientRect();
          if (button.isConnected && !button.closest('[data-nobs-sticky-cart]') && rect.width > 0 && rect.height > 0) return button;
        }
        return null;
      }

      function updateStickyCart() {
        if (stickyFrame) return;
        stickyFrame = window.setTimeout(function () {
          stickyFrame = 0;
          var stickyCart = document.querySelector('[data-nobs-sticky-cart]');
          var stickyButton = stickyCart && stickyCart.querySelector('[data-nobs-sticky-add]');
          if (!stickyCart || !stickyButton) return;
          stickyCart.dataset.nobsStickyReady = 'delegated-v2';
          var mainAddButton = findMainAddButton();
          var footer = document.querySelector('footer, .shopify-section-group-footer-group');
          var footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight * 0.84;
          var shouldShow = Boolean(mainAddButton) &&
            (window.matchMedia('(max-width: 749px)').matches || mainAddButton.getBoundingClientRect().bottom < 0) &&
            !footerVisible;

          stickyCart.classList.toggle('is-visible', shouldShow);
          stickyCart.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
          stickyButton.tabIndex = shouldShow ? 0 : -1;
          stickyButton.disabled = !mainAddButton || mainAddButton.disabled;
          var label = stickyButton.disabled ? 'В КОЛИЧКАТА' : 'ДОБАВИ В КОЛИЧКА';
          if (stickyButton.textContent !== label) stickyButton.textContent = label;
        }, 32);
      }

      document.addEventListener('click', function (event) {
        var stickyButton = event.target.closest && event.target.closest('[data-nobs-sticky-add]');
        if (!stickyButton) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        var mainAddButton = findMainAddButton();
        if (!mainAddButton || mainAddButton.disabled) {
          updateStickyCart();
          return;
        }
        // Use the current button so Appstle keeps control of the selected plan,
        // three-bottle quantity, gifts and native Shopify subscription checkout.
        mainAddButton.click();
        updateStickyCart();
      }, true);

      window.addEventListener('scroll', updateStickyCart, { passive: true });
      window.addEventListener('resize', updateStickyCart, { passive: true });
      document.addEventListener('shopify:section:load', updateStickyCart);
      new MutationObserver(function (records) {
        var relevant = records.some(function (record) {
          var target = record.target;
          return !target.closest || !target.closest('[data-nobs-sticky-cart]');
        });
        if (relevant) updateStickyCart();
      }).observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });
      window.nobsMagCoreStickyController = { refresh: updateStickyCart };
      updateStickyCart();
    })();
